import { PortalConfig } from '../types';

export const portalDefaultConfig: PortalConfig = {
  allowSyndication: false,
  allowLMS: false,
};
